import React from 'react';
import { Heading} from './Heading'

export const Address = props => {
  const {subHeading, city, firstLine, secondLine, postcode } = props.address;
  return (
    <div className="contact-details__address col-xs-12 col-md-4">
    <Heading content={ subHeading } size="h3" style={props.headingColor}/>
        <p style={props.textColor}>{ firstLine }<br />
        { secondLine }<br />
        { city }<br />
        { postcode }</p>
  </div>
  )
};


// WEBPACK FOOTER //
// src/client/components/common/CMS/elements/Address.js